export default "__VITE_ASSET__ixUvvg0O__"